export default {
  computed: {
    questionsLeftFirstQuestion() {
      return this.questionsLeft(0)
    },
    questionsLeftSecondQuestion() {
      return this.questionsLeft(1)
    },
  },
  methods: {
    questionsLeft(index) {
      const questions = this.getSecurityQuestions()

      const left = questions.filter(
        (q) => q.question !== this.securityQuestions[1 - index].question
      )

      return left
    },
  },
}
